import Alpine from 'alpinejs';

Alpine.data('chat', (adminURL, userEmail) => ({
  adminURL,
  errors: [],
  isNewTicket: false,
  message: '',
  openTickets: [],
  closedTickets: [],
  ticketsPerPage: 1,
  loading: true,
  init() {
    this.getTickets();
    this.fillForm();
  },
  fillForm() {
    const form = document.querySelector('.wpcf7');
    const inputUser = document.querySelector('input[name="user_email"]');

    console.log('xdxd', inputUser);

    inputUser.value = userEmail;
  },
  setFilter(e) {
    this.errors = [];
    this.category = e.detail.by;
  },
  createTicket() {
    this.errors = [];

    const formData = new FormData();
    formData.append('action', 'createTicket');
    formData.append('message', this.message);
    if (this.category) formData.append('category_id', this.category);

    if (!this.category) this.errors.push('Kategoria wpisu jest wymagana');
    if (!this.message) this.errors.push('Wiadomość jest wymagana');

    if (this.errors.length) return;

    const submitFormBtn = document.querySelector('.wpcf7-submit');
    submitFormBtn.click();

    fetch(this.adminURL, {
      method: 'POST',
      body: formData,
    })
      .then((res) => res.json())
      .then((res) => {
        console.log('xdxd res', res);
        this.isNewTicket = false;
        this.message = '';
        this.getTickets();
      });
  },
  getTickets() {
    this.loading = true;
    const formData = new FormData();

    formData.append('action', 'getTickets');

    fetch(this.adminURL, {
      method: 'POST',
      body: formData,
    })
      .then((res) => res.json())
      .then((res) => {
        this.openTickets = res.open_tickets;
        this.closedTickets = res.closed_tickets;
        this.loading = false;
      });
  },
  showMoreTickets() {
    this.ticketsPerPage += 1;
  },
  // init() {
  //   this.$watch('page', (value) => this.$dispatch('page-query', value));
  // },
  // setPage() {
  //   this.fetchPosts();
  // },
  // setFilter(e) {
  //   const cats = e.detail.by;
  //   this.cats = cats;
  //   this.page = 1;
  //   this.fetchPosts();
  // },
  // fetchPosts() {
  //   const formData = new FormData();
  //   formData.append('action', 'fetchPosts');
  //   formData.append('page', this.page);
  //   if (this.cats.length) formData.append('category_id', this.cats);
  //   fetch(adminURL, {
  //     method: 'POST',
  //     body: formData,
  //   })
  //     .then((res) => res.json())
  //     .then((res) => {
  //       this.items = res.posts;
  //       this.lastPage = res.lastPage;
  //       this.showDefault = false;
  //     });
  // },
}));
